import * as _ from 'lodash';

export const getStats = store => store.stats;

export const getWorldmap = store => _.get(getStats(store), 'worldmap.data');
export const getCountryStats = store =>
    _.get(getWorldmap(store), 'countryStats');
export const getNumberOfPlayers = store =>
    _.get(getStats(store), 'numberOfPlayers.data');
export const getNumberOfPlayersWithOpenAlerts = store =>
    _.get(getStats(store), 'numberOfPlayersWithOpenAlerts.data');
export const getNumberOfActivePlayers = store =>
    _.get(getStats(store), 'numberOfActivePlayers.data');
// export const getNumberOfActivePlayersForTheLastDay = store => _.get(getNumberOfActivePlayers(store));
export const getNumberOfEventsForTheLastDay = store =>
    _.get(getStats(store), 'numberOfEventsForTheLastDay.data');

export const getNumberOfDepositsForTheLastDay = store =>
    _.get(
        getNumberOfEventsForTheLastDay(store),
        'numberOfDepositsForTheLastDay'
    );
export const getNumberOfWithdrawalsForTheLastDay = store =>
    _.get(
        getNumberOfEventsForTheLastDay(store),
        'numberOfWithdrawalsForTheLastDay'
    );
export const getNumberOfBetsForTheLastDay = store =>
    _.get(getNumberOfEventsForTheLastDay(store), 'numberOfBetsForTheLastDay');

export const getTopRiskyPlayers = store =>
    _.get(getStats(store), 'topRiskyPlayers.data');
export const getRegistrationsPerMonth = store =>
    _.get(getStats(store), 'registrationsPerMonth.data');
export const getOverallSystemRisk = store =>
    _.get(getStats(store), 'overallSystemRisk');
export const getOpenAlertsPerRuleCategory = store =>
    _.get(getStats(store), 'openAlerts');
